import { Injectable } from '@angular/core';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { Globals } from "../../common/globals";
import { DatePipe } from '@angular/common';
import { style } from '@angular/core/src/animation/dsl';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { HttpClient } from '@angular/common/http';
import { pdfMakeChinese } from './chinese-fonts';
import { pdfMakeJapanese } from './japanese-fonts';

@Injectable()

export class PDFGenerator {
    pdfUsertype: boolean = false;

    constructor(private globals: Globals,private translateService: TranslateService) {
    }



    getTTFContent(){
        let ttfs = {
            "en" : pdfFonts.pdfMake.vfs,
            "zh" : pdfMakeChinese.vfs,
            "ja" : pdfMakeJapanese.vfs
        }
        return ttfs[localStorage.getItem('configmax-lang')];
    }
    pdfGenerate(releasearr: any, dateVal: Date, verName, fineNameStr: any, relGadate: any, pdfUsertype, excludeInternal): void {
        var datePipe = new DatePipe('en-US');
        var date_pdf = datePipe.transform(dateVal, 'MMMM dd, yyyy');
        pdfMake.vfs = this.getTTFContent();
        let gadate: Date = new Date(relGadate);
        var date_ga = datePipe.transform(gadate, 'yyyy');
        var today = datePipe.transform(new Date(), 'yyyy');
        var dateStr = "";
        if (date_ga < today) {
            dateStr = date_ga + "-" + today;
        } else {
            dateStr = today;
        }
        let recommendedLimit = this.translateService.instant('recommendedLimit')
        var detailData = {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            defaultStyle: {
                fontSize: 9,
                fontFamily: this.globals.ARIAL_FONT,
            },
            header: function (page, pages) {
                if (page > 1) {
                    return { text: "\n" +  recommendedLimit + "\n", alignment: 'center' };
                }
            },
            footer: function (page, pages) {
                if (page > 1) {
                    return [
                        { text: "Omnissa LLC", alignment: 'left', fontSize: 7, margin: [30, 0, 0, 0] },
                        { text: page, alignment: 'right', fontSize: 7, margin: [0, 0, 30, 0] }
                    ]
                } else if (page == 1) {
                   // return {
                    //    image: "../../../../images/Omnissa_logo.png"
                   //     , width: 230, alignment: 'left', margin: [30, -100 , 0, 0]
                   // };//margin: [1, -410,0, 0]
                }
            },
            content: [
                { text: this.translateService.instant('pdfpageLabel'), style: 'header_first' },
                {
                    text: verName + "\n" + this.translateService.instant('updatedOn') + " " +
                        date_pdf, style: 'header', pageBreak: 'after'
                },
                { text: "\n\n" + this.translateService.instant('pdfLink') },
                { text: "" + this.globals.docsURL, style: 'url_style' },
              //  { text: this.translateService.instant('pdfFeedback') },
             //   { text: this.globals.configMaxemail_alias, style: 'url_style' },
                {
                    text: [{
                        text: this.globals.VMWARE_ADDR + "\n\n" +
                            // this.globals.COPYRIGHT + dateStr + this.globals.VMWARE_RIGHTS, style: 'align_style'
                            this.globals.VMWARE_RIGHTS, style: 'align_style'
                    },
                    {
                    //    text: this.globals.VMWARE_TRADEMARK, style: 'url_style'
                    }], alignment: 'left', margin: [0, 600, 0, 0],
                    pageBreak: 'after'
                },
                { text: "\n\n" + this.translateService.instant('home.paraOne') + "\n\n", style: 'into_style', },
                {

                     text: [{text: "\n\n" + this.translateService.instant('home.disclaimer') + "\n\n\n\n", style: 'disclaimer_style' }]
                },
                { text: " \n\n", pageBreak: 'after' },
                this.table(releasearr, pdfUsertype, excludeInternal)
            ],
            styles: {
                header: {
                    alignment: 'right',
                    fontFamily: 'Arial Rounded MT Bold", "Helvetica Rounded", Arial, sans-serif',
                    color: '#6F6F73',
                    fontSize: 13,
                },
                header_first: {
                    fontFamily: 'Arial Rounded MT Bold", "Helvetica Rounded", Arial, sans-serif',
                    fontSize: 19,
                    bold: true,
                    color: '#00688F',
                    alignment: 'right'
                },
                url_style: {
                    color: '#0096D4'
                },
                align_style: {
                    alignment: 'left'
                },
                into_style: {
                    alignment: 'left',
                    fontSize: 11
                },
                disclaimerkey_style: {
                    alignment: 'left',
                    bold: true
                },
                disclaimer_style: {
                    alignment: 'left',
                }
            }
        }
        var filename = fineNameStr + ' Configuration_Maximums' + '.pdf'
        if (pdfUsertype === true) {
            filename = fineNameStr + ' Configuration_Maximums' + '_internal' + '.pdf'
        }
        pdfMake.createPdf(detailData).download(filename);
    }

    buildTableBody(data) {
        var body = [];
        body.push([this.translateService.instant('category'),"            ", this.translateService.instant('viewLimits.limit'), this.translateService.instant('viewLimits.description')]);
        for (let dataConfig of data) {
            var dataRowMain = [];
            var desc = " ";
            if(dataConfig.comments != undefined)
            desc = dataConfig.comments;
            dataRowMain.push({ text: dataConfig.name + "\n \n" +desc , bold: true, colSpan: 4 });
            dataRowMain.push("\n\n\n\n");
            body.push(dataRowMain);
            if (dataConfig.configs.length > 0) {
                dataConfig.configs.forEach(function (row) {
                    var dataRow = [];
                    dataRow.push({ text: row.headername + "\n" });
                    dataRow.push({ text: row.keyname + "\n" });
                    if (row.attrValue == undefined) {
                        dataRow.push("");
                    } else {
                        dataRow.push({ text: row.attrValue + "\n" });
                    }
                    if (row.description == undefined) {
                        dataRow.push("");
                    } else {
                        dataRow.push({ text: row.description + "\n" });
                    }
                    body.push(dataRow);
                });
            }
        }
        return body;
    }

    loggedInBuildTableBody(data, excludeInternal) {
        var body = [];
        body.push([this.translateService.instant('category'), "            ",this.translateService.instant('viewLimits.limit'), this.translateService.instant('viewLimits.description')]);
        for (let dataConfig of data) {
            var dataRowMain = [];
            var desc = " ";
            if(dataConfig.comments != undefined)
            desc = dataConfig.comments;
            dataRowMain.push({ text: dataConfig.name + "\n" + desc , bold: true, colSpan: 4 });
            dataRowMain.push("\n\n\n\n");
            body.push(dataRowMain);
            if (dataConfig.configs.length > 0) {
                dataConfig.configs.forEach(function (row) {
                    if (row.internal === excludeInternal) {
                        return true;
                    } else {
                        var dataRow = [];
                        dataRow.push({ text: row.headername + "\n" });
                        dataRow.push({ text: row.keyname + "\n" });
                        if (row.attrValue == undefined)
                            dataRow.push("");
                        else
                            dataRow.push({ text: row.attrValue + "\n" });
                        if (row.description == undefined)
                            dataRow.push("");
                        else
                            dataRow.push({ text: row.description + "\n" });
                        body.push(dataRow);
                    }
                });
            }
        }
        return body;
    }

    table(data, pdfUsertype, excludeInternal) {
        if (pdfUsertype === false) {
            return {
                table: {
                    widths: ['30%','30%','10%','30%'],
                    headerRows: 1,
                    dontBreakRows: true,
                    keepWithHeaderRows: 1,
                    body: this.buildTableBody(data),
                }
            };
        } else {
            return {
                table: {
                    widths: ['30%','30%','10%','30%'],
                    headerRows: 1,
                    dontBreakRows: true,
                    keepWithHeaderRows: 1,
                    body: this.loggedInBuildTableBody(data, excludeInternal),
                }
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/pdf/pdfgenerator.ts